/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { DocumentDownloadDto } from '../../models/document-download-dto';

export interface GetHistoricalInformationDocument$Params {
  id: string;
}

export function getHistoricalInformationDocument(
  http: HttpClient,
  rootUrl: string,
  params: GetHistoricalInformationDocument$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<DocumentDownloadDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    getHistoricalInformationDocument.PATH,
    'get',
  );
  if (params) {
    rb.query('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DocumentDownloadDto>;
      }),
    );
}

getHistoricalInformationDocument.PATH = '/document/historicalInformation';
